const KEY_VERIFY_SENT_AT = "bs_last_verification_sent_at";
const KEY_RESET_SENT_AT = "bs_last_reset_sent_at";

const clampMs = (n) => (n < 0 ? 0 : n);

export const durationLeft = (startTime, duration) => {
  const start = typeof startTime === "number" ? startTime : Number(startTime || 0);
  return clampMs(start + duration - Date.now());
};

const getTs = (k) => {
  const raw = localStorage.getItem(k);
  const n = raw ? Number(raw) : 0;
  return Number.isFinite(n) ? n : 0;
};
const setTs = (k, ts) => localStorage.setItem(k, String(ts));
const delTs = (k) => localStorage.removeItem(k);

const buildStatus = (lastSentAtMs, expirationMs, retryMs) => {
  const exists = lastSentAtMs > 0 && durationLeft(lastSentAtMs, expirationMs) > 0;
  const retryCountdown = durationLeft(lastSentAtMs, retryMs);
  return {
    exists,
    retry: { duration: retryMs, countdown: retryCountdown },
    duration: expirationMs,
  };
};

const Oob = {
  // verification
  getVerificationLastSentAt: () => getTs(KEY_VERIFY_SENT_AT),
  markVerificationSentNow: () => setTs(KEY_VERIFY_SENT_AT, Date.now()),
  clearVerificationLastSentAt: () => delTs(KEY_VERIFY_SENT_AT),
  // reset
  getResetLastSentAt: () => getTs(KEY_RESET_SENT_AT),
  markResetSentNow: () => setTs(KEY_RESET_SENT_AT, Date.now()),
  clearResetLastSentAt: () => delTs(KEY_RESET_SENT_AT),

  buildStatus,
  durationLeft,
};

export default Oob;
